module.exports = __webpack_public_path__ + "img/ic_fuel.d3d085a1.svg";